// These must be the first lines in src/index.js
import React from 'react'
import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import ReactDOM from 'react-dom'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import App from './App'
import './index.css'
import './output.css' // generated by tailwind, run `yarn tailwind:watch`
import reportWebVitals from './reportWebVitals'
import './utils/i18n'

ReactDOM.render(
  <React.StrictMode>
    <App />
    <ToastContainer position="top-right" hideProgressBar style={{ marginTop: 60 }} />
  </React.StrictMode>,
  document.getElementById('root'),
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
